import type { ThirdPartyPortalStatus } from '@risksmart-app/trpc/src/types';
import type { GetThirdPartyPortalStatusQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetThirdPartyPortalStatusDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetThirdPartyPortalStatusArgs = Record<string, never>;

/**
 * CS-only diagnostic (RSP-6736): whether the caller's org is provisioned for
 * third-party portal login. Bridges the V2 Hasura action
 * (`getThirdPartyPortalStatus`) and the V3 tRPC query
 * (`frontend.thirdPartyPortal.getPortalStatus`) behind the `trpc` flag.
 */
export const useGetThirdPartyPortalStatus = createQueryHook<
  UseGetThirdPartyPortalStatusArgs,
  ThirdPartyPortalStatus,
  GetThirdPartyPortalStatusQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.thirdPartyPortal.getPortalStatus.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ getThirdPartyPortalStatus: data }),
  graphqlDocument: GetThirdPartyPortalStatusDocument,
  graphqlFetchPolicy: 'cache-first',
});
